<corp-pop-menu>
    <ng-template #trigger>
        <button 
            content-pop-trigger
            class="cursor-pointer [&_*]:cursor-pointer relative top-[2px] inline-block leading-none transition-all hover:text-primary-500">
            <i class="material-symbols-outlined !text-[20px] md:!text-[22px]">
                <img  [src]="currentLang?.imgPath" [alt]="currentLang?.label" class="h-5 w-5">
            </i>
        </button>
    </ng-template>

    <ng-template #content>
        <div class="language-menu-dropdown shadow-3xl absolute top-full z-[1] mt-[18px] w-[190px] rounded-md bg-white pt-[13px] transition-all md:mt-[21px] md:w-[190px] md:pt-[14px] ltr:left-0 rtl:right-0 dark:bg-[#0c1427] dark:shadow-none ltr:lg:right-0 ltr:md:left-auto rtl:md:right-auto rtl:lg:left-0">
                <span class="block px-[20px] pb-[14px] text-sm font-semibold text-black md:text-[15px] dark:text-white">
                    {{ 'i18n.common.widget.language-menu.choose' | translate }}
                </span>
                <ul>
                    @for(lang of _lang$(); track lang.id) {
                        <li class="border-t border-dashed border-gray-100 dark:border-[#172036]">
                            <button (click)="switchLanguage(lang)" type="button" class="d-block w-full px-[20px] py-[12px] font-medium text-black dark:text-white">
                                <div class="flex items-center">
                                    <img [src]="lang.imgPath" class="w-[30px] ltr:mr-[10px] rtl:ml-[10px]" [alt]="lang.label">
                                    <!-- 'i18n.common.widget.language-menu.fr' -->
                                    {{ lang.label| translate }}
                                </div>
                            </button>
                        </li>
                    }
                </ul>
            </div>
    </ng-template>
</corp-pop-menu>
















<!-- 




<app-dropdown-menu #dropdown>
    <button dropdown-button
            class="relative top-[2px] inline-block pr-[12px] leading-none transition-all hover:text-primary-500">
        <i class="material-symbols-outlined !text-[20px] md:!text-[22px]">
            @switch (currentLang) {
            @case('fr') {
            <img src="images/flags/france.svg" alt="Français" class="h-5 w-5">
            }
            @case('en') {
            <img src="images/flags/uk.svg" alt="English" class="h-5 w-5">
            }
            @default{
            <span>🌐</span>
            }
            }
        </i>
        <i class="ri-arrow-down-s-line absolute top-1/2 -right-[3px] -mt-[2px] -translate-y-1/2 text-[15px]"></i>
    </button>

    <div dropdown-content>
        <div class="language-menu-dropdown shadow-3xl absolute top-full z-[1] mt-[18px] w-[200px] rounded-md bg-white pt-[13px] transition-all md:mt-[21px] md:w-[240px] md:pt-[14px] ltr:left-0 rtl:right-0 dark:bg-[#0c1427] dark:shadow-none ltr:lg:right-0 ltr:md:left-auto rtl:md:right-auto rtl:lg:left-0">
            <span class="block px-[20px] pb-[14px] text-sm font-semibold text-black md:text-[15px] dark:text-white">
                {{ 'i18n.common.widget.language-menu.choose' | translate }}
            </span>
            <ul>
                <li class="border-t border-dashed border-gray-100 dark:border-[#172036]">
                    <button (click)="switchLanguage('fr')" type="button" class="d-block w-full px-[20px] py-[12px] font-medium text-black dark:text-white">
                        <div class="flex items-center">
                            <img src="images/flags/france.svg" class="w-[30px] ltr:mr-[10px] rtl:ml-[10px]" alt="Français">
                            {{ 'i18n.common.widget.language-menu.fr' | translate }}

                        </div>
                    </button>
                </li>

                <li class="border-t border-dashed border-gray-100 dark:border-[#172036]">
                    <button (click)="switchLanguage('en')" type="button" class="d-block w-full px-[20px] py-[12px] font-medium text-black dark:text-white">
                        <div class="flex items-center">
                            <img src="images/flags/uk.svg" class="w-[30px] ltr:mr-[10px] rtl:ml-[10px]" alt="English">
                            {{ 'i18n.common.widget.language-menu.en' | translate }}
                        </div>
                    </button>
                </li>

            </ul>

        </div>
    </div>
</app-dropdown-menu> -->
